// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './table-fraction-calculation.properties';

const TABLE_FRACTION_CALCULATION_TO_PERSISTENCE_KEY = {
  NONE: 'NONE',
  GRAND_TOTAL: 'GRAND_TOTAL',
  ROW_TOTAL: 'ROW_TOTAL'
} as const;

/** @see net/disy/cadenza/attribute/olap/TableFractionCalculation.java */
export type TableFractionCalculation = keyof typeof TABLE_FRACTION_CALCULATION_TO_PERSISTENCE_KEY;

export const TableFractionCalculation = {
  values: Object.keys(TABLE_FRACTION_CALCULATION_TO_PERSISTENCE_KEY) as readonly TableFractionCalculation[],
  toPersistenceKey: (value: TableFractionCalculation) => TABLE_FRACTION_CALCULATION_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = TableFractionCalculation.values.find(key => TABLE_FRACTION_CALCULATION_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No TableFractionCalculation for key: ${persistenceKey}`); }
    return value;
  },
  i18n: (value: TableFractionCalculation) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>
